module.exports = __webpack_public_path__ + "img/Camera.9fb99906.svg";